
export interface PhaseTranslation {
  title: string;
  description: string;
}


export class Phase {
  id?: number;
  translations: { [key: string]: PhaseTranslation };
  start_date?: string;
  end_date?: string;
  has_dashed_line?: boolean;
  product?: number;

  constructor(
    translations: { [key: string]: PhaseTranslation } = {},
    start_date?: string,
    end_date?: string,
    has_dashed_line?: boolean,
    product?: number
  ) {
    this.translations = translations;
    this.start_date = start_date;
    this.end_date = end_date;
    this.has_dashed_line = has_dashed_line;
    this.product = product;
  }

}
